<template>
	<div class="cards custom-scrollbar" :class="{ cards__short: isAdmin }">
		<div class="cards__content" v-if="!loadingUser">
			<h5 class="cards__heading" v-if="articles.length > 0">
				Referenced articles
			</h5>
			<LinkCard
				v-for="article in articles"
				:article="article"
				:key="article.id"
				@click.native="linkSelected(article)"
			/>
		</div>
		<div class="cards__spinner" v-if="loadingUser">
			<Spinner />
		</div>
	</div>
</template>

<script>
import LinkCard from "./LinkCard";
import Article from "../../../services/article";
import Spinner from "../../shared/Spinner";

export default {
	name: "SideLinksPanel",
	components: {
		LinkCard,
		Spinner,
	},
	props: ["linkedArticles", "articleId", "boxArticlesIds", "isAdmin"],
	data: function () {
		return {
			articles: [],
			loadingUser: false,
			filteredArticles: [],
		};
	},
	methods: {
		getResumes: function () {
			if (!this.filteredArticles) {
				this.articles = [];
				this.$emit('cardsloaded', false);
				return;
			}
			this.loadingUser = true;
			let articleIds = this.filteredArticles.map((a) => a.id);
			Article.instance()
				.getArticleResumeList({ ids: articleIds })
				.then((res) => {
					this.articles = res.data;
					this.filterArticles();
					this.loadingUser = false;
					this.$emit('cardsloaded', this.checkIfCards());
				})
				.catch((error) => {
					console.error(error);
					this.loadingUser = false;
				});
		},
		linkSelected: function (article) {
			let currentQuery = this.$route.query;
			this.$router.push({
				path: this.$route.path,
				query: { ...currentQuery, resume: article.id },
			});
		},
		filterArticles: function () {
			this.articles = this.articles.filter((a) => {
				return a.parentArticleId != this.articleId;
			});

			this.articles = this.articles.filter((a) => {
				return a.articleType == "HOW_TO" || a.articleType == "SERVICE";
			});
		},
		checkIfCards: function () {
			return this.articles ? this.articles.some((a) => {
				return a.articleType == "HOW_TO" || a.articleType == "SERVICE";
			}) : false;
		},
		excludeBoxedArticles: function () {
			if (!this.boxArticlesIds) {
				this.filteredArticles = this.linkedArticles;
				return;
			}
			if (!this.linkedArticles) {
				this.filteredArticles = [];
				return;
			}
			this.filteredArticles = this.linkedArticles.filter(
				(a) => !this.boxArticlesIds.includes(a.id)
			);
		},
	},
	watch: {
		linkedArticles: function () {
			this.excludeBoxedArticles();
			this.getResumes();
		},
		boxArticlesIds: function () {
			this.excludeBoxedArticles();
			this.getResumes();
		},
	},
};
</script>

<style scss scoped>

.cards {
	padding: 2rem;
	overflow: auto;
}

.cards__heading {
	margin-bottom: 2rem;
}

</style>